import client from '../../../common/client';

export const GET_SHOWS = 'GET_SHOWS';
export const GET_FEATURED_SHOW = 'GET_FEATURED_SHOW';
export const ADD_WATCH = 'ADD_WATCH';
export const DELETE_WATCH = 'DELETE_WATCH';
export const GET_EPISODES = 'GET_EPISODES';
export const GET_VIDEO = 'GET_VIDEO';
export const RESET_SHOW_COMPLETION = 'RESET_SHOW_COMPLETION';

export const getShows = () => ({
  promise: client.get('tv-shows', { 'with-upcoming-showtimes': true }),
  type: GET_SHOWS,
});

export const getFeaturedShow = () => ({
  promise: client.get('tv-shows/featured'),
  type: GET_FEATURED_SHOW,
});

export const addWatch = id => ({
  promise: client.post('tv-watches', { show_id: id }),
  type: ADD_WATCH,
});

export const deleteWatch = id => ({
  promise: client.delete(`tv-watches/${id}`),
  type: DELETE_WATCH,
  id,
});

export const getEpisodes = showId => ({
  promise: client.get(`tv-shows/${showId}/episodes`),
  type: GET_EPISODES,
});

export const getEpisodesReset = () => ({
  type: `${GET_EPISODES}_RESET`,
});

export const getVideo = (showId, episodeId) => ({
  promise: client.get(`tv-shows/${showId}/episodes/${episodeId}/video`, null, {
    credentials: 'include', // Required for browser to respect Set-Cookie headers
  }),
  type: GET_VIDEO,
});

export const resetCompletion = showId => ({
  promise: client.delete(`tv-shows/${showId}/progress`),
  type: RESET_SHOW_COMPLETION,
});



// WEBPACK FOOTER //
// ./src/subscription/tv/redux/actions.js